/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Existing_AnalysingInputs */

const en_existing_analysing = /** @type {(inputs: Existing_AnalysingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysing codebase`)
};

const id_existing_analysing = /** @type {(inputs: Existing_AnalysingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menganalisis codebase`)
};

/**
* | output |
* | --- |
* | "Analysing codebase" |
*
* @param {Existing_AnalysingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const existing_analysing = /** @type {((inputs?: Existing_AnalysingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Existing_AnalysingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_existing_analysing(inputs)
	return en_existing_analysing(inputs)
});